export const load = () => {
  const $element = $('#page-data');
  if ($element.length === 0) return [];
  const text = $('#page-data').text();
  if (text.trim().length === 0) return [];
  return JSON.parse(text);
};

